import React, { Fragment } from "react";
import Swal from "sweetalert2";
import { create } from "../../../constants/apiRoutes";

const Upstream = () => {
  const handleService = async (service) => {
    const { value: confirmed } = await Swal.fire({
      title: `Are you sure to ${service}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${service}!`,
      cancelButtonText: `Don't ${service}`,
    });

    if (confirmed) {
      try {
        let postData = {
          ServiceName: "GoldDataFeeder",
          Action: service,
        };

        const res = await create(`Rates/upstream`, postData);
        Swal.fire({
          icon: "success",
          title: res,
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (error) {
        console.error("Error On Service", error);
      }
    } 
  };

  return (
    <Fragment>
      <h2 className="text-2xl font-bold mb-4">
        Rates Upstream Service Settings
      </h2>

      <div className="p-2 rounded-xl border-2 border-gray-200 bg-white">
        <button
          type="button"
          onClick={() => handleService("start")}
          className="text-sm font-semibold bg-green-500 m-4 text-white w-24 h-9 rounded-lg hover:bg-green-600 "
        >
          Start Service
        </button>
        <button
          type="button"
          onClick={() => handleService("stop")}
          className="text-sm font-semibold bg-red-500 m-4 text-white w-24 h-9 rounded-lg hover:bg-red-600 "
        >
          Stop Service
        </button>
      </div>
    </Fragment>
  );
};

export default Upstream;
